import { useSuspenseQuery } from '@tanstack/react-query';
import { paths } from '@/generated/supplier-experience-api';
import apiClient from '@/lib/apiClient';

type BuyerLendingRequestsResponse = paths['/buyers/lending']['get']['responses']['200']['content']['application/json'];
type BuyerLendingRequests = BuyerLendingRequestsResponse['data'];

const fetchBuyerLendingRequests = async (): Promise<BuyerLendingRequests> => {
  const response = await apiClient.get('api/supplier-experience/buyers/lending').json<BuyerLendingRequestsResponse>();
  return response.data ?? [];
};

const useBuyerLendingRequests = ({ enabled = true }: { enabled?: boolean }) => {
  return useSuspenseQuery<BuyerLendingRequests, Error>({
    queryKey: ['buyerLendingRequests'],
    queryFn: () => (enabled ? fetchBuyerLendingRequests() : []),
  });
};

export default useBuyerLendingRequests;
